import { fetchJson, authHeaders } from './api';
import { fileUrl } from './api';
// src/FreelancerDetailView.js — Vista dettaglio dal lato Casa di Produzione (no alert panel)
import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Stack,
  Typography,
  Chip,
  CircularProgress,
  IconButton,
  Divider,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LockIcon from '@mui/icons-material/Lock';
import GroupIcon from '@mui/icons-material/Group';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import UserProfilePanel from './UserProfilePanel';
import ProductionAssistantPanel from './components/ProductionAssistantPanel';
import CollaborationsWidget from './components/CollaborationsWidget';
import TeamMiniPanel from './components/TeamMiniPanel';
import { setFavoriteFreelancer, upsertAvailabilityAlert, setPriorityFreelancer } from './api';
import AvailabilityCalendar from './AvailabilityCalendar';

// Contenitore sezione con la stessa larghezza/padding delle altre
const Section = ({ title, children, sx }) => (
  <Box sx={{ px: { xs: 1, sm: 2 }, pt: 2, ...sx }}>
    {title && (
      <Typography variant="overline" sx={{ color: 'text.secondary', letterSpacing: '0.08em' }}>
        {title}
      </Typography>
    )}
    {children}
  </Box>
);



// Helpers "date-only" per evitare slittamenti timezone
function dateOnlyUTC(y, m, d) {
  return new Date(Date.UTC(y, m, d));
}
function ymdUTC(d) {
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}

// Converte le produzioni in un Set di 'YYYY-MM-DD' occupati (no timezone shift)
function buildBusySetFromProduzioni(list = []) {
  const set = new Set();
  if (!Array.isArray(list)) return set;

  const parse = (s) => {
    if (!s) return null;
    const only = String(s).split('T')[0]; // prendi solo YYYY-MM-DD
    const [y, m, d] = only.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d); // <-- locale
  };

  const ymd = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
      d.getDate()
    ).padStart(2, '0')}`;

  for (const p of list) {
    const s =
      parse(p?.data_inizio_contratto) ||
      parse(p?.data_inizio_prevista) ||
      parse(p?.data_inizio) ||
      parse(p?.startDate);

    const e =
      parse(p?.data_fine_contratto) ||
      parse(p?.data_fine_prevista) ||
      parse(p?.data_fine) ||
      parse(p?.endDate) ||
      s;

    if (!s) continue;

    let d = new Date(s.getFullYear(), s.getMonth(), s.getDate());
    const end =
      e && e >= s
        ? new Date(e.getFullYear(), e.getMonth(), e.getDate())
        : d;

    let _sc=0; while (d.getTime() <= end.getTime() && _sc++ < 1000) {
      set.add(ymd(d));
      d.setDate(d.getDate() + 1);
    }
  }

  return set;
}


const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3001/api';


// Componente note sticky sidebar
function NotesSidebar({ notes, notesLoading, newNote, setNewNote, noteVisibility, setNoteVisibility, noteSaving, saveNote, deleteNote }) {
  const GOLD = '#d4a550';
  const GOLD_DIM = 'rgba(212,165,80,0.10)';
  const GOLD_BORDER = 'rgba(212,165,80,0.28)';
  const BORDER = 'rgba(255,255,255,0.07)';
  const TEXT = '#e8e6df';
  const TEXT_DIM = 'rgba(232,230,223,0.45)';
  const BG_ITEM = '#13131e';
  return (
    <div style={{ background: '#0f0f17', border: `1px solid ${GOLD_BORDER}`, borderRadius: 10, padding: '12px 14px', fontFamily: "'Inter', sans-serif" }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 14, color: GOLD }}>✎</span>
          <span style={{ fontSize: 13, fontWeight: 700, color: GOLD }}>Note Private</span>
        </div>
        <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 20, border: `1px solid ${GOLD_BORDER}`, background: GOLD_DIM, color: GOLD }}>🔒 Solo tu</span>
      </div>
      <textarea rows={2} placeholder="Scrivi una nota..." value={newNote} onChange={e => setNewNote(e.target.value)}
        style={{ width: '100%', background: BG_ITEM, border: `1px solid ${BORDER}`, borderRadius: 6, color: TEXT, fontSize: 12, padding: '7px 10px', fontFamily: "'Inter', sans-serif", resize: 'none', outline: 'none', boxSizing: 'border-box', marginBottom: 7 }}
      />
      <div style={{ display: 'flex', gap: 7, alignItems: 'center', marginBottom: 10 }}>
        <select value={noteVisibility} onChange={e => setNoteVisibility(e.target.value)}
          style={{ flex: 1, background: BG_ITEM, border: `1px solid ${BORDER}`, borderRadius: 6, color: TEXT, fontSize: 11, padding: '5px 8px', fontFamily: "'Inter', sans-serif", outline: 'none', cursor: 'pointer' }}>
          <option value="private">🔒 Solo io</option>
          <option value="team">👥 Team coordinatori</option>
        </select>
        <button onClick={saveNote} disabled={!newNote.trim() || noteSaving}
          style={{ fontSize: 11, fontWeight: 700, padding: '5px 12px', borderRadius: 6, cursor: newNote.trim() ? 'pointer' : 'not-allowed', border: `1px solid ${GOLD_BORDER}`, background: GOLD_DIM, color: GOLD, fontFamily: "'Inter', sans-serif", opacity: !newNote.trim() || noteSaving ? 0.5 : 1 }}>
          {noteSaving ? '...' : 'Salva'}
        </button>
      </div>
      {notesLoading ? (
        <div style={{ textAlign: 'center', color: TEXT_DIM, fontSize: 12, padding: '8px 0' }}>...</div>
      ) : notes.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#444', fontSize: 11, padding: '6px 0' }}>Nessuna nota.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {notes.map(n => (
            <div key={n.id} style={{ padding: '8px 10px', borderRadius: 6, background: 'rgba(255,255,255,0.02)', border: `1px solid ${BORDER}` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                <span style={{ fontSize: 12, color: TEXT, flex: 1, whiteSpace: 'pre-wrap' }}>{n.note}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                  <span style={{ fontSize: 9, fontWeight: 700, padding: '1px 6px', borderRadius: 20, border: `1px solid ${GOLD_BORDER}`, background: GOLD_DIM, color: GOLD }}>
                    {n.visibility === 'team' ? '👥 Team' : '🔒 Privata'}
                  </span>
                  <button onClick={() => deleteNote(n.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#444', fontSize: 13, padding: 0, lineHeight: 1 }}
                    onMouseEnter={e => e.target.style.color='#f87171'} onMouseLeave={e => e.target.style.color='#444'}>✕</button>
                </div>
              </div>
              <div style={{ fontSize: 10, color: '#444', marginTop: 3 }}>
                {new Date(n.created_at).toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: '2-digit' })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


function AggiungiAllaRosa({ freelancerId, token }) {
  const [productions, setProductions] = React.useState([]);
  const [rosePresenti, setRosePresenti] = React.useState([]);
  const [selectedProd, setSelectedProd] = React.useState('');
  const [saving, setSaving] = React.useState(false);
  const [msg, setMsg] = React.useState(null);

  React.useEffect(() => {
    fetch(`${API_BASE}/productions`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => setProductions(Array.isArray(data) ? data : []))
      .catch(() => {});
    fetch(`${API_BASE}/postplans/rosa/freelancer/${freelancerId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => setRosePresenti(data?.productions || []))
      .catch(() => {});
  }, [token, freelancerId]);

  const handleAdd = async () => {
    if (!selectedProd) return;
    setSaving(true);
    setMsg(null);
    try {
      const res = await fetch(`${API_BASE}/postplans/rosa/${selectedProd}/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ freelancerId }),
      });
      const data = await res.json();
      if (res.ok) {
        setMsg(data.alreadyPresent ? 'Già presente nella rosa' : 'Aggiunto alla rosa ✓');
        setSelectedProd('');
      } else {
        setMsg('Errore: ' + (data.error || 'sconosciuto'));
      }
    } catch {
      setMsg('Errore di rete');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ mt: 2, p: 2, borderRadius: 3, border: '1px solid rgba(212,165,80,0.2)', bgcolor: '#13161c' }}>
      <Typography variant="subtitle2" sx={{ color: '#d4a550', fontWeight: 700, mb: 1.5 }}>
        Aggiungi alla rosa
      </Typography>
      <Select
        size="small"
        fullWidth
        displayEmpty
        value={selectedProd}
        onChange={e => setSelectedProd(e.target.value)}
        sx={{ bgcolor: '#1a1d23', color: '#e0e0e0', borderRadius: 2, fontSize: 13, mb: 1.5 }}
      >
        <MenuItem value=""><em>Seleziona produzione...</em></MenuItem>
        {productions.map(p => (
          <MenuItem key={p.id} value={p.id}>{p.titolo || p.title || p.name || `Produzione #${p.id}`}</MenuItem>
        ))}
      </Select>
      <Button
        fullWidth
        variant="contained"
        disabled={!selectedProd || saving}
        onClick={handleAdd}
        sx={{ bgcolor: '#d4a550', color: '#0e1116', fontWeight: 700, borderRadius: 2, '&:hover': { bgcolor: '#c49440' } }}
      >
        {saving ? 'Salvataggio...' : 'Aggiungi alla rosa'}
      </Button>
      {msg && (
        <Typography sx={{ mt: 1, fontSize: 12, color: msg.includes('✓') ? '#4caf50' : '#f87171', textAlign: 'center' }}>
          {msg}
        </Typography>
      )}
      {rosePresenti.length > 0 && (
        <Box sx={{ mt: 1.5, pt: 1.5, borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <Typography sx={{ fontSize: 11, color: '#8a8a9a', mb: 0.5 }}>GIÀ PRESENTE IN:</Typography>
          {rosePresenti.map(p => (
            <Typography key={p.production_id} sx={{ fontSize: 12, color: '#d4a550' }}>
              · {p.name || `Produzione #${p.production_id}`}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default function FreelancerDetailView({ freelancerId: freelancerIdProp, userIdForFavorites, token: tokenProp, onBack }) {
  const params = useParams();
  const freelancerId = freelancerIdProp || Number(params.freelancerId) || null;
  const token = tokenProp;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState(null);
  const [notes, setNotes] = useState([]);
  const [snack, setSnack] = useState(null);

  const handleToggleFavorite = async (enabled) => {
    const favId = userIdForFavorites || profile?.user_id || freelancerId;
    console.log("[favorites] freelancerId:", freelancerId, "userIdForFavorites:", userIdForFavorites, "profile.user_id:", profile?.user_id, "favId:", favId);
    try { await setFavoriteFreelancer(favId, enabled); } catch(e) { console.error(e); }
  };
  const handleUpsertAlert = async (leadDays) => {
    try { await upsertAvailabilityAlert(freelancerId, leadDays); } catch(e) { console.error(e); }
  };
  const handleTogglePriority = async (enabled) => {
    try { await setPriorityFreelancer(freelancerId, enabled); } catch(e) { console.error(e); }
  };
  const [notesLoading, setNotesLoading] = useState(false);
  const [newNote, setNewNote] = useState('');
  const [noteVisibility, setNoteVisibility] = useState('private');
  const [noteSaving, setNoteSaving] = useState(false);
    // Token effettivo: usa la prop se c'è, altrimenti prendi dal storage
  const effectiveToken =
    token ||
    (typeof localStorage !== 'undefined' && (localStorage.getItem('token') || localStorage.getItem('authToken'))) ||
    (typeof sessionStorage !== 'undefined' && (sessionStorage.getItem('token') || sessionStorage.getItem('authToken'))) ||
    '';

    const onMessage = async () => {
  try {
    const otherUserId = Number(profile?.user_id);
    if (!otherUserId) {
      alert("Impossibile avviare chat: profile.user_id mancante.");
      return;
    }

    const res = await fetchJson("/messages/conversations", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${effectiveToken}`,
      },
      body: JSON.stringify({ otherUserId }),
    });

    const cid = res?.id;
    if (!cid) {
      alert("Errore: conversazione non creata.");
      return;
    }

    window.location.href = `/messages?cid=${cid}`;
  } catch (e) {
    console.error("[UI][PROFILE] create conversation error", e);
    alert(e?.message || "Errore avvio conversazione");
  }
};


  // Fetch note del coordinatore
  const fetchNotes = async (fid) => {
    if (!fid) return;
    setNotesLoading(true);
    try {
      const res = await fetch(`${API_BASE}/notes/freelancer/${fid}`, {
        headers: { Authorization: `Bearer ${effectiveToken}` },
      });
      const data = await res.json().catch(() => []);
      setNotes(Array.isArray(data) ? data : []);
    } catch { setNotes([]); }
    finally { setNotesLoading(false); }
  };

  const saveNote = async () => {
    if (!newNote.trim()) return;
    setNoteSaving(true);
    try {
      const noteTargetId = profile?.user_id || freelancerId;
      const res = await fetch(`${API_BASE}/notes/freelancer/${noteTargetId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${effectiveToken}` },
        body: JSON.stringify({ note: newNote.trim(), visibility: noteVisibility }),
      });
      const saved = await res.json();
      if (res.ok) {
        setNotes(prev => [saved, ...prev]);
        setNewNote('');
      }
    } catch (e) { console.error('saveNote error', e); }
    finally { setNoteSaving(false); }
  };

  const deleteNote = async (noteId) => {
    try {
      await fetch(`${API_BASE}/notes/${noteId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${effectiveToken}` },
      });
      setNotes(prev => prev.filter(n => n.id !== noteId));
    } catch (e) { console.error('deleteNote error', e); }
  };

  // Giorni occupati come Set('YYYY-MM-DD') da passare al calendario
  const busySet = React.useMemo(() => {
    const raw =
      profile?.maestranze ??
      profile?.produzioni ??
      profile?.productions ??
      [];
      const today = new Date().toISOString().slice(0,10);
      const active = (Array.isArray(raw) ? raw : []).filter(p => {
        const fine = p?.data_fine_contratto || p?.data_fine || "";
        return fine && String(fine).slice(0,10) >= today;
      });
      return buildBusySetFromProduzioni(active);
  }, [profile]);

  useEffect(() => {
    let alive = true;

    const prev = typeof window !== 'undefined' ? window.__HIDE_ALERTS__ : undefined;
    if (typeof window !== 'undefined') window.__HIDE_ALERTS__ = true;

    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchJson(
  `/freelancers/${freelancerId}`,
  { headers: authHeaders(effectiveToken) }
);
if (!alive) return;
setProfile(data || null);
        if (data) fetchNotes(data.user_id || freelancerId);
        // Registra visualizzazione profilo
        fetchJson(`/freelancers/${freelancerId}/view`, { method: 'POST' }).catch(() => {});

      } catch (e) {
        if (!alive) return;
        setError('Errore di rete');
        setProfile(null);
      } finally {
        if (alive) setLoading(false);
      }
    })();


    return () => {
      if (typeof window !== 'undefined') window.__HIDE_ALERTS__ = prev;
      alive = false;
    };
  }, [freelancerId, token]);
// === Avatar del freelancer (URL risolto) ===
const rawAvatar =
  profile?.profile_image_url ??
  profile?.profileImageUrl ??
  profile?.image_url ??
  profile?.avatar_url ??
  profile?.avatar ??
  '';

const normalizedAvatarPath = rawAvatar
  ? (/^https?:\/\//i.test(rawAvatar)
      ? rawAvatar
      : rawAvatar.startsWith('/uploads/')
        ? rawAvatar
        : rawAvatar.startsWith('uploads/')
          ? `/${rawAvatar}`
          : `/uploads/${rawAvatar}`)
  : '';

const avatarSrc = fileUrl(normalizedAvatarPath);

// Bio normalizzata (compatibile con bio/descrizione)
const bioText = (() => {
  const s = typeof profile?.bio === 'string' ? profile.bio
          : typeof profile?.descrizione === 'string' ? profile.descrizione
          : '';
  return (s || '').trim();
})();


  // Header “scheda” con avatar/nome/ruoli
  const Header = (
    <Stack direction="row" alignItems="center" spacing={2} sx={{ p: 2 }}>

      {onBack && (
        <IconButton onClick={onBack} size="small" sx={{ mr: 0.5 }}>
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
      )}

      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography sx={{
            fontFamily: 'Kanit, sans-serif',
            fontWeight: 700,
            fontSize: { xs: 20, md: 24 },
            color: '#f0ece4',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
          {(profile?.nome || '') + ' ' + (profile?.cognome || '') || '—'}
        </Typography>

        <Stack direction="row" spacing={1} sx={{ mt: 0.5, flexWrap: 'wrap' }}>
          {(Array.isArray(profile?.ruoli) && profile.ruoli.length
            ? profile.ruoli
            : profile?.ruolo
            ? [profile.ruolo]
            : []
          )
            .slice(0, 3)
            .map((r) => (
              <Chip
                key={r}
                size="small"
                icon={<WorkOutlineIcon sx={{ fontSize: 16 }} />}
                label={r}
                sx={{
                  fontWeight: 500,
                  fontSize: 12,
                  bgcolor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#aaa',
                }}
              />
            ))}
        </Stack>
      </Box>
    </Stack>
  );

  if (loading) {
    return (
      <Box sx={{ p: 2 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error || !profile) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">{error || 'Profilo non disponibile'}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 0 }}>
      <Paper
        elevation={0}
        sx={{
          mb: 2,
          borderRadius: 3,
          border: '1px solid rgba(212,165,80,0.2)',
          boxShadow: '0 6px 18px rgba(0,0,0,0.3)',
          overflow: 'hidden',
          backgroundColor: '#13161c',
        }}
      >
        {Header}
        <Divider />


{/* pannello profilo (readOnly) + note in sidebar */}
<Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 280px', lg: '1fr 320px' }, gap: 2, p: { xs: 1, sm: 2 }, alignItems: 'start' }}>
  <Box>
    <UserProfilePanel
      initialProfile={profile}
      token={effectiveToken}
      endpointProfile={`/freelancers/${freelancerId}`}
      endpointAvailability={`/freelancers/${freelancerId}/availability`}
      readOnly
      onMessage={onMessage}
      collaborationsSlot={
        <CollaborationsWidget
          freelancerUserId={profile?.user_id || freelancerId}
          token={effectiveToken}
          companyName={''}
        />
      }
    />
  </Box>
  {/* SIDEBAR DESTRA — Assistente produzione + Team Suggerito */}
  <Box sx={{ position: { lg: 'sticky' }, top: { lg: 16 }, alignSelf: 'start' }}>
    <Box sx={{ mb: 2 }}>
      <NotesSidebar
        freelancerId={freelancerId}
        effectiveToken={effectiveToken}
        notes={notes}
        notesLoading={notesLoading}
        newNote={newNote}
        setNewNote={setNewNote}
        noteVisibility={noteVisibility}
        setNoteVisibility={setNoteVisibility}
        noteSaving={noteSaving}
        saveNote={saveNote}
        deleteNote={deleteNote}
      />
    </Box>
    <ProductionAssistantPanel
      freelancerId={freelancerId}
      freelancerName={profile ? `${profile.nome ?? ''} ${profile.cognome ?? ''}`.trim() : 'Freelance'}
      initIsFavorite={!!profile?.is_favorite}
      initLeadDays={profile?.alert_lead_days ?? null}
      initIsPrioritized={!!profile?.is_prioritized}
      onToggleFavorite={handleToggleFavorite}
      onUpsertAlert={handleUpsertAlert}
      onTogglePrioritize={handleTogglePriority}
      token={effectiveToken}
    />
    <AggiungiAllaRosa freelancerId={freelancerId} token={effectiveToken} />
  </Box>
</Box>

      </Paper>
    </Box>
  );
}
